import * as React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Popover from "@mui/material/Popover";
import { Icon, Stack, Tooltip, Typography } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import { COMPETITION_WIN_CONDITIONS } from "lib/constants";
import { getWinConditionDescription } from "utils/HelperFunctions";

function InfoPopover({ competition }) {
  const theme = useTheme();
  const isMobileDisplay = useMediaQuery(theme.breakpoints.only("xs"));
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;

  return (
    <>
      {isMobileDisplay ? (
        <Stack alignItems="center" onClick={handlePopoverOpen}>
          <Icon>help_outline</Icon>
          <Typography className="icon-typography">Info</Typography>
        </Stack>
      ) : (
        <Tooltip title="Click to view competition information">
          <Icon sx={{ cursor: "pointer" }} onClick={handlePopoverOpen}>
            help_outline
          </Icon>
        </Tooltip>
      )}

      <Popover
        id={id}
        open={open}
        sx={{ minWidth: "20rem" }}
        anchorEl={anchorEl}
        className="competition-info-popover"
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Stack spacing={1} p={2}>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Win condition</MDTypography>
            <MDTypography className="value">
              {competition?.CompetitionWinCondition?.condition || "-"}
            </MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">How to win</MDTypography>
            <MDTypography sx={{ maxWidth: "19rem", textAlign: "right" }} className="value">
              {getWinConditionDescription(
                competition?.CompetitionWinCondition?.condition,
                competition.endDatetime
              )}
            </MDTypography>
          </Stack>

          {COMPETITION_WIN_CONDITIONS.FIRST_TO_KPI_TARGET ===
            competition?.CompetitionWinCondition?.condition && (
            <Stack spacing={2} direction="row" justifyContent="space-between">
              <MDTypography className="title">KPI target</MDTypography>
              <MDTypography className="value">{competition?.target || "-"}</MDTypography>
            </Stack>
          )}
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Start time</MDTypography>
            <MDTypography className="value">
              {moment
                .tz(competition.startDatetime, loginUser.timezone)
                .format("dddd MMMM D, hh:mm a")}
            </MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">End time</MDTypography>
            <MDTypography className="value">
              {competition.endDatetime
                ? moment
                    .tz(competition.endDatetime, loginUser.timezone)
                    .format("dddd MMMM D, hh:mm a")
                : "-"}
            </MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Created by</MDTypography>
            <MDTypography className="value">{competition?.createdByUser?.name || "-"}</MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Type</MDTypography>
            <MDTypography className="value">
              {competition?.type === "tremendous payout" ? "Tremendous Payout" : "Unranked"}
            </MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Open to join</MDTypography>
            <MDTypography className="value">{competition.joinable ? "Yes" : "No"}</MDTypography>
          </Stack>
        </Stack>
      </Popover>
    </>
  );
}

export default InfoPopover;
